import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent {
  appName = 'Asha Sathi App';
  companyName = 'Velodynamics Pvt. Ltd.';
  email = 'support@velocetechinsights.com';
}
